import * as React from "react";
import classnames from "classnames";
/* empty css             */
const Divider = (props) => {
  const { className, orientation = "horizontal", caption, ...rest } = props;
  if (orientation === "vertical") {
    return /* @__PURE__ */ React.createElement(BareDivider, { ...props });
  }
  if (!caption) {
    return /* @__PURE__ */ React.createElement(BareDivider, { ...props });
  }
  return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("divider-wrapper", className) }, /* @__PURE__ */ React.createElement(BareDivider, { ...props, "aria-hidden": "true" }), /* @__PURE__ */ React.createElement("span", { className: "divider__caption" }, caption), /* @__PURE__ */ React.createElement(BareDivider, { ...props }));
};
function BareDivider(props) {
  const { className, orientation = "horizontal", theme = "regular", caption: _, ...rest } = props;
  return /* @__PURE__ */ React.createElement(
    "hr",
    {
      className: classnames("divider", `divider--${orientation}`, className, {
        "divider--light": theme === "light"
      }),
      "aria-orientation": orientation,
      "aria-hidden": rest["aria-hidden"],
      ...rest
    }
  );
}
export {
  Divider
};
//# sourceMappingURL=Divider.js.map
